
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/courses/writing",
      function () {
        return require("private-next-pages/next/courses/writing.tsx");
      }
    ]);
  